// extracted by mini-css-extract-plugin
export var container = "_5t-0";
export var containerTopRight = "_5t-1";